import { useSortable } from "@dnd-kit/sortable";
import { CSS } from "@dnd-kit/utilities";
import { GripVertical } from "react-bootstrap-icons";

const SortableTh = ({ id, className, style, onClick, role, children }) => {
  const { attributes, listeners, setNodeRef, isDragging, isOver, transform, transition } = useSortable({ id });
  return (
    <th
      ref={setNodeRef}
      {...attributes}
      {...listeners}
      role={role}
      onClick={onClick}
      className={`${className} relative group hover:pl-6 transition-[padding] duration-150`}
      style={{
        ...style,
        opacity: isDragging ? 0.3 : 1,
        cursor: "grab",
        background: isOver && !isDragging ? "#e4e4e7" : undefined,
        transform: CSS.Transform.toString(transform),
        transition,
      }}
    >
      <GripVertical className="absolute left-1 top-1/2 -translate-y-1/2 h-5 w-5 text-zinc-500 opacity-0 group-hover:opacity-100 group-hover:text-zinc-400 transition-opacity pointer-events-none select-none" />
      {children}
    </th>
  );
};

export default SortableTh;
